import type { SearchRequest } from "@elastic/elasticsearch/lib/api/types";
import type { UscAccessoriesTypes } from "../actions/UscAccessoriesActions";
import { USC_ACCESSORIES_INIT, USC_ACCESSORIES_SET_FAILED } from "../actions/UscAccessoriesActions";
import type { UscAccessoryType, UscPackType } from "../../utils/accessoryUtils";

export type UscAccessoriesReducerType = {
    initialized: boolean;
    fetchFailed: boolean;
    esQuery: SearchRequest | null; // Query used for the ES endpoint. Used for debugging purposes.
    accessoryResults: UscAccessoryType[];
    packResults: UscPackType[];
};

export const initialStateUscAccessories: UscAccessoriesReducerType = {
    initialized: false,
    fetchFailed: false,
    esQuery: null,
    accessoryResults: [],
    packResults: [],
};

const UscAccessoriesReducer = (
    state: UscAccessoriesReducerType = initialStateUscAccessories,
    action: UscAccessoriesTypes,
): UscAccessoriesReducerType => {
    switch (action.type) {
        case USC_ACCESSORIES_INIT:
            const { packs, accessories, esQuery } = action;
            return { ...state, packResults: packs, accessoryResults: accessories, esQuery, initialized: true };

        case USC_ACCESSORIES_SET_FAILED: {
            return { ...state, fetchFailed: action.failed };
        }

        default:
            return state;
    }
};

export default UscAccessoriesReducer;
